<div class="w-full space-y-4">

  <!-- Page Header -->
  <div class="flex items-center justify-between pb-4 border-b border-slate-200">
    <div class="flex items-center gap-3">
      <div class="h-10 w-10 bg-slate-100 rounded-lg flex items-center justify-center">
        <mat-icon class="text-slate-600">sms</mat-icon>
      </div>
      <div>
        <h2 class="text-sm font-bold tracking-widest uppercase text-slate-800">
          Scheduled SMS
        </h2>
        <p class="text-xs text-slate-500 font-medium mt-0.5">
          View and manage scheduled SMS messages
        </p>
      </div>
    </div>
  </div>

  <!-- ================= FILTERS ================= -->
  <div class="bg-white rounded-lg shadow-sm border border-slate-300 px-4 py-3">
    <div class="flex flex-col md:flex-row flex-wrap items-start md:items-center gap-3 w-full">

      <!-- Transaction Type -->
      <mat-form-field appearance="outline" class="w-full md:w-[160px]">
        <mat-label>Transaction Type</mat-label>
        <mat-select [(ngModel)]="filterTransactionType" (selectionChange)="applyFilters()">
          <mat-option *ngFor="let type of transactionTypes" [value]="type.value">
            {{ type.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Customer Name -->
      <mat-form-field appearance="outline" class="w-full md:flex-1">
        <mat-label>Customer Name</mat-label>
        <mat-select [(ngModel)]="filterCustomerId" (selectionChange)="applyFilters()">
          <mat-option [value]="null">All Customers</mat-option>
          <mat-option *ngFor="let c of customerList" [value]="c.customerId">
            {{ c.customerName }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- SMS Status -->
      <mat-form-field appearance="outline" class="w-full md:w-[160px]">
        <mat-label>SMS Status</mat-label>
        <mat-select [(ngModel)]="filterStatus" (selectionChange)="applyFilters()">
          <mat-option value="All">All</mat-option>
          <mat-option *ngFor="let s of statusOptions" [value]="s.value">{{ s.viewValue }}</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Is Active -->
      <mat-form-field appearance="outline" class="w-full md:w-[120px] md:mr-4">
        <mat-label>Is Active</mat-label>
        <mat-select [(ngModel)]="filterIsActive" (selectionChange)="applyFilters()">
          <mat-option value="All">All</mat-option>
          <mat-option value="Yes">Active</mat-option>
          <mat-option value="No">Inactive</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Buttons -->
      <div class="flex items-center justify-end gap-3 h-auto md:h-[56px] shrink-0 w-full md:w-auto md:ml-auto">
        <button (click)="lFN_ResetFilters()" class="flex-1 md:flex-none px-6 py-2.5 rounded-lg
                    text-slate-500 text-[12px] font-medium tracking-widest uppercase
                    bg-slate-100 text-slate-900
                    transition-all duration-200">
          Reset
        </button>
        <button (click)="lFN_SearchSMS()" class="px-6 py-2 rounded-md
                 bg-gradient-to-r from-slate-900 to-black
                 text-white text-[12px] font-medium tracking-widest uppercase
                 shadow hover:from-black hover:to-slate-800
                 transition-all duration-150 whitespace-nowrap">
          Search
        </button>
      </div>

    </div>
  </div>

  <!-- ================= TABLE ================= -->
  <div class="bg-white rounded-lg shadow-sm border border-slate-300">
    <div class="overflow-x-auto w-full">
      <table mat-table [dataSource]="dataSource" matSort class="w-full whitespace-nowrap">

        <!-- Sr No -->
        <ng-container matColumnDef="srNo">
          <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white text-xs uppercase text-center w-16">Sr No.
          </th>
          <td mat-cell *matCellDef="let row; let i = index" class="text-center text-sm font-medium text-slate-500">
            {{ paginator ? (paginator.pageIndex * paginator.pageSize) + i + 1 : i + 1 }}
          </td>
        </ng-container>

        <!-- Transaction Number -->
        <ng-container matColumnDef="transactionNo">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="bg-gray-900 text-white text-xs uppercase px-4">
            Transaction No</th>
          <td mat-cell *matCellDef="let row" class="text-sm font-medium text-slate-700 px-4">{{ row.transactionNo }}
          </td>
        </ng-container>

        <!-- Customer Name -->
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="bg-gray-900 text-white text-xs uppercase px-4">
            Customer Name</th>
          <td mat-cell *matCellDef="let row" class="text-sm px-4">{{ row.customerName }}</td>
        </ng-container>

        <!-- Service Name -->
        <ng-container matColumnDef="serviceName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="bg-gray-900 text-white text-xs uppercase px-4">
            Service Name</th>
          <td mat-cell *matCellDef="let row" class="text-sm px-4">{{ row.serviceName }}</td>
        </ng-container>

        <!-- Service Expiry -->
        <ng-container matColumnDef="serviceExpiry">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="bg-gray-900 text-white text-xs uppercase px-4">
            Service Expiry</th>
          <td mat-cell *matCellDef="let row" class="text-sm px-4">{{ row.serviceExpiry | date:'dd-MMM-yyyy' }}</td>
        </ng-container>

        <!-- SMS Scheduled ON -->
        <ng-container matColumnDef="smsScheduledOn">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="bg-gray-900 text-white text-xs uppercase px-4">
            SMS Scheduled ON</th>
          <td mat-cell *matCellDef="let row" class="text-sm px-4">{{ row.smsScheduledOn | date:'dd-MMM-yyyy' }}</td>
        </ng-container>

        <!-- SMS Status -->
        <ng-container matColumnDef="smsStatus">
          <th mat-header-cell *matHeaderCellDef mat-sort-header
            class="bg-gray-900 text-white text-xs uppercase text-center px-4">SMS Status</th>
          <td mat-cell *matCellDef="let row" class="text-center px-4">
            <span class="inline-block px-3 py-1 rounded-full text-[10px] font-bold tracking-widest uppercase border"
              [ngClass]="{
                  'bg-emerald-100 text-emerald-800 border-emerald-300': row.smsStatus === 'Sent' || row.smsStatus === 'Delivered',
                  'bg-amber-100 text-amber-800 border-amber-300': row.smsStatus === 'Pending' || row.smsStatus === 'Scheduled',
                  'bg-rose-100 text-rose-800 border-rose-300': row.smsStatus === 'Failed' || row.smsStatus === 'Cancelled',
                  'bg-slate-100 text-slate-800 border-slate-300': row.smsStatus !== 'Sent' && row.smsStatus !== 'Delivered' && row.smsStatus !== 'Pending' && row.smsStatus !== 'Scheduled' && row.smsStatus !== 'Failed' && row.smsStatus !== 'Cancelled'
                }">
              {{ row.smsStatus }}
            </span>
          </td>
        </ng-container>

        <!-- Is Active -->
        <ng-container matColumnDef="isActive">
          <th mat-header-cell *matHeaderCellDef class="bg-gray-900 text-white text-xs uppercase text-center px-4">Is
            Active</th>
          <td mat-cell *matCellDef="let row" class="text-center px-4">
            <button (click)="lFN_ToggleActive(row)" class="w-20 text-center px-0 py-1.5 rounded-full
                         text-[10px] font-semibold tracking-widest uppercase
                         transition-all duration-200 border" [ngClass]="row.isActive === 'YES'
                    ? 'bg-emerald-200 text-emerald-900 border-emerald-600 hover:bg-emerald-300'
                    : 'bg-rose-200 text-rose-900 border-rose-600 hover:bg-rose-300'">
              {{ row.isActive === 'YES' ? 'Active' : 'Inactive' }}
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="hover:bg-slate-50 transition-colors"></tr>
      </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>